import { Component } from '@angular/core';

@Component({
   selector: 'ndt-register-quick-filter',
   template: '<ng-content></ng-content>',
   styles: [':host { display: contents; }'],
   standalone: false,
})
export class RegisterQuickFilterComponent {}
